module.exports = __webpack_public_path__ + "img/category.9b114a04.svg";